
import { Component, Vue } from "vue-property-decorator";
import Boletines from "@/components/Web/Boletines.vue";

@Component({
  components: {
    Boletines
  },
  meta: {
    // sets document title
    title: "Boletines - Municipalidad de Maipú",
    // optional; sets final title as "Index Page - My Website", useful for multiple level meta
    //titleTemplate: title => `${title} - My Website`,

    // meta tags
    meta: {
      description: {
        name: "description",
        content: "Revisa aquí los boletines municipales."
      },
      keywords: { name: "keywords", content: "Maipú" },
      equiv: {
        "http-equiv": "Content-Type",
        content: "text/html; charset=UTF-8"
      }
    }
  }
})
export default class BoletinesView extends Vue {
  private mounted() {
    document.title = "Boletines - Municipalidad de Maipú";
  }
}
